import Hero from "../../frontend/components/Hero";
import CalculatorsImag1 from "../../assets/images/StampDutyCalculator.jpg";
import StampDutyCalculator from "../../frontend/components/calculators/StampDutyCalculator";

const StampDutyPage = () => {
  return (
    <div>
      <Hero title="Stamp Duty" subtitle="" backgroundImage={CalculatorsImag1} />
      <StampDutyCalculator />
      {/* <div className="landing-page">
            </div> */}
    </div>
  );
};

export default StampDutyPage;
